import React, {useEffect, useRef, useState} from 'react';
import {View, Text, Platform, Modal, Linking, ActivityIndicator} from 'react-native';
import {WebView} from 'react-native-webview';
import {useSelector, useDispatch} from 'react-redux';
import {mainSite} from '../config';
import {useIsFocused} from '@react-navigation/native';
import {setCurrentWorkout, setCurrentWorkoutActivity, fetchLatestWorkout} from '../reducers/cbcWorkoutSlice';
import Bugsnag from "@bugsnag/expo";
import {PivotLogging} from '../reducers/cbcLoggingSlice';
import styled from 'styled-components/native';
import {
    WorkoutsParent,
    WorkoutContainerText,
    WorkoutTextHeader,
    CerebrocoreCommonTextComponent,
    WorkoutContainerHeaderThree,
    WorkoutCommonButton
} from '../styles/common-styles';

import DynamicModal from "../modals/DynamicModal";

function GameView(props) {
    const dispatch = useDispatch();

    const [workoutId, setWorkoutId] = useState(0)
    const [isLastExercise, setIsLastExercise] = useState(0)
    const [errorCount, setErrorCount] = useState(1);
    const [showModal, setShowModal] = useState(false);
    const [finalErrorModal, setFinalErrorModal] = useState(false);
    const [gameUrlStr, setGameUrlStr] = useState(``);
    const [loadingTimeout, setLoadingTimeout] = useState(null);
    const [showDynamicModal, setShowDynamicModal] = useState(false);
    const [modalMessaging, setModalMessaging] = useState();
    const [parsedData, setParsedData] = useState();

    const {current_workout_activity, current_workout} = props.route.params;


    useEffect(() => {
        if (props.route.params.isWorkout != false) {
            setWorkoutId(current_workout.id);
            setGameUrlStr(`${mainSite}/activity-view?activity_name=${current_workout_activity.shortcode}&activity_id=${current_workout_activity.id}&game_type=${currentActivityGameType}&workout_id=${workoutId}&last_exercise=${isLastExercise}&auth_token=${apiAuthToken}`)
        }
    }, [props.route.params.isWorkout, current_workout.id]); // Dependencies

    var onLayout;

    useEffect(() => {
        //Determine if last exercise in workout.
        const exerciseIndex = current_workout.activities.indexOf(current_workout_activity);
        if (exerciseIndex === (current_workout.activities.length - 1)) {
            setIsLastExercise(1);
        } else if (current_workout_activity.type == "free_choice" || current_workout_activity.current_workout_name == "Free Choice") {
            setIsLastExercise(1);
        }
    });

    useEffect(() => {
        if (!isFocused) {
            Bugsnag.notify('Gameview not in focus.');
            props.navigation.navigate('gameview', {
                current_workout_activity,
                current_workout,
            });
        } else {
            dispatch(PivotLogging({moduleName: 'GameView', consoleLog: 'Game in focus'}));
        }
    }, []);

    if (Platform.OS == 'web') {
        const [dimensions, setDimensions] = useState({width: 0, height: 0});

        onLayout = (event) => {
            const {width, height} = event.nativeEvent.layout;
            setDimensions({width, height});
        };

        useEffect(() => {
            if (window.parent !== window && dimensions.height >= 150) {
                window.parent.postMessage({
                    height: dimensions.height,
                }, '*');
            }
        }, [dimensions]);
    }

    useEffect(() => {
        props.navigation.setOptions({
            title: current_workout_activity.name,
        });
    }, [props.navigation]);

    // get the state values we want to access from the authorization reducer
    const {userId, wpAuthorizationToken, apiAuthToken} = useSelector(
        (state) => state.cbcAuthorization
    );


    const currentActivityGameType = current_workout_activity.type == 'assessment' ? 0 : 1;
    dispatch(PivotLogging({
        moduleName: 'GameView',
        consoleLog: `${mainSite}/activity-view?activity_name=${current_workout_activity.shortcode}&activity_id=${current_workout_activity.id}&game_type=${currentActivityGameType}&workout_id=${workoutId}&last_exercise=${isLastExercise}&auth_token=${apiAuthToken}`
    }));

    const webViewRef = useRef(null);
    const isFocused = useIsFocused();

    useEffect(() => {
        if (isFocused && webViewRef.current) {
            webViewRef.current.reload();
        }
    }, [isFocused]);

    const onMessage = (event) => {
        try {
          let data;
          if (Platform.OS === 'web') {
            data = event.data;
          } else {
            data = event.nativeEvent.data;
          }
      
          dispatch(PivotLogging({ moduleName: 'GameView', consoleLog: `Event data from web: ${data}` }));
      
          if (typeof data === 'string') {
            let parsedData;
            try {
              parsedData = JSON.parse(data);
            } catch (e) {
              console.log('Error parsing data:', e);
              if (Platform.OS === 'web') {
                // Retry onMessage in hopes that parsedData state is updated
                return onMessage(event);
              } else {
                return;
              }
            }
      
            setParsedData(parsedData);
            console.log('parsed data', parsedData);
      
            try {
              if (typeof parsedData['modal_messaging'] === 'object' && parsedData['modal_messaging'] !== null) {
                console.log('parsedData.modal_messaging: ', parsedData['modal_messaging']);
                setModalMessaging(parsedData['modal_messaging']);
                setShowDynamicModal(true);
              } else {
                completedActivity(parsedData);
              }
            } catch (e) {
              console.log('parsedData.modal_messaging not available yet', e);
            }
      
            dispatch(PivotLogging({ moduleName: 'GameView', consoleLog: `Parsed data: ${parsedData}` }));
          }
        } catch (e) {
          console.log('Error in onMessage:', e);
        }
      };

    const completedActivity = (parsedData) => {
        setShowDynamicModal(false)
        console.log('completed activity parseddata: ', parsedData);

        const currentWorkoutIndex = current_workout.activities.findIndex(activity => activity === current_workout_activity);
        console.log(currentWorkoutIndex, current_workout.activities, current_workout_activity);
        try {
            if (parsedData['is_workout'] === true) {
                if (JSON.stringify(parsedData['local_json_data']) === JSON.stringify(current_workout)) {
                    props.navigation.navigate('dashboard');
                    return;
                    dispatch(PivotLogging({moduleName: 'GameView', consoleLog: 'Same workout, fetching latest'}));
                }

                if (parsedData['local_json_data.workout_completed'] === true && parsedData['user_interaction_type'] === 0) {
                    props.navigation.navigate('dashboard');
                    return;
                } else {
                    dispatch(PivotLogging({
                        moduleName: 'GameView',
                        consoleLog: 'Activity completing, setting state to local state from site.'
                    }));
                    dispatch(setCurrentWorkout(parsedData['local_json_data']));
                    dispatch(setCurrentWorkoutActivity());
                }
            }

            if (parsedData['completed'] == true && parsedData['is_workout'] == true && currentWorkoutIndex !== -1) {
                console.log('called continueworkout');
                console.log()
                props.navigation.navigate('continueworkout', {userInteractionType: parsedData.user_interaction_type});
            } else if (parsedData['completed'] == false && parsedData['completed'] == true) {
                dispatch(PivotLogging({moduleName: 'GameView', consoleLog: 'Navigated to dashboard'}));
                Bugsnag.leaveBreadcrumb('Navigated to dashboard.');
                Bugsnag.notify('Navigated to dashboard from GameView.');
                props.navigation.navigate('dashboard');
            } else if(parsedData['completed'] == true && parsedData['is_workout'] == true && currentWorkoutIndex === -1){
                dispatch(PivotLogging({moduleName: 'GameView', consoleLog: 'Navigated to dashboard'}));
                Bugsnag.leaveBreadcrumb('Navigated to dashboard.');
                Bugsnag.notify('Navigated to dashboard from GameView.');
                props.navigation.navigate('dashboard');
            }

            if (parsedData.is_workout == false || currentWorkoutIndex === -1) {
                props.navigation.navigate('dashboard');
            }
        } catch(e){
            console.log('parsedData not available yet' , e);
        }
    }

    if (Platform.OS == 'web') {
        useEffect(() => {
            window.addEventListener('message', onMessage);
            return () => {
                window.removeEventListener('message', onMessage);
            };
        }, []);
    }

    const handleError = (syntheticEvent) => {
        const {nativeEvent} = syntheticEvent;
        setErrorCount(prevErrorCount => prevErrorCount + 1);
        console.error('WebView error: ', nativeEvent);
        const logMessage = `Debug Logging: Route Params: ${JSON.stringify(props.route.params)}\n ___
    Workout ID: ${workoutId}\n___ 
    Is Last Exercise: ${isLastExercise}\n___ 
    Game URL String: ${gameUrlStr}`;
        Bugsnag.leaveBreadcrumb(logMessage);

        if (errorCount < 3) {
            // Show a modal indicating that the game failed to load and a retry is underway
            setShowModal(true);
            Bugsnag.notify(`Game failed to load after ${errorCount} tries.`);
            setTimeout(() => {
                setShowModal(false);
                webViewRef.current?.reload();
            }, 5000); // Close the modal and retry after 3 seconds
        } else {
            // After 3 failed tries, show a different modal and notify bugsnag
            setFinalErrorModal(true);
            clearTimeout(loadingTimeout);
            Bugsnag.notify('Game failed to load after 3, displaying error and returning user to dashboard.');
        }
    };

    const handleLoadStart = () => {
        // Set a timeout of 10 seconds to call handleError function
        clearTimeout(loadingTimeout);
        setLoadingTimeout(setTimeout(() => {
            handleError('Loading timeout');
        }, 20000)); // 10 seconds
    };

    const handleLoadEnd = () => {
        // Clear the timeout
        clearTimeout(loadingTimeout);
    };

    return Platform.OS === 'web' ? (
        <iframe onLayout={onLayout}
                src={`${mainSite}/activity-view?activity_name=${current_workout_activity.shortcode}&activity_id=${current_workout_activity.id}&game_type=${currentActivityGameType}&workout_id=${workoutId}&last_exercise=${isLastExercise}`}
                height={'100%'}
                width={'100%'}
        />
    ) : (
        <View style={{height: "100%", width: "100%"}}>
            {showDynamicModal &&
                <DynamicModal modal_message_exercise={modalMessaging} callback={completedActivity}/>
            }
            {/* Error modals */}
            <Modal
                animationType="slide"
                transparent={true}
                visible={showModal}
            >
                <ModalViewParent>
                    <ModalView>
                        <WorkoutTextHeader>Error</WorkoutTextHeader>
                        <WorkoutContainerText style={{marginTop: 10}}>We failed to load your exercise, lets try that
                            again.</WorkoutContainerText>
                    </ModalView>
                </ModalViewParent>
            </Modal>

            <Modal
                animationType="slide"
                transparent={true}
                visible={finalErrorModal}
            >
                <ModalViewParent>
                    <ModalView>
                        <WorkoutTextHeader>Error</WorkoutTextHeader>
                        <WorkoutContainerText style={{marginTop: 10}}>We are unable to load your exercise.{'\n'}{'\n'}Please
                            reach out to a developer:</WorkoutContainerText>
                        <Text style={{color: 'blue', marginTop: 10}}
                              onPress={() => Linking.openURL('mailto:support@cerebrocoreusa.com')}
                        >
                            support@cerebrocoreusa.com
                        </Text>
                        <ButtonCont onPress={() => {
                            props.navigation.navigate('dashboard');
                        }}>
                            <ButtonText>EXIT</ButtonText>
                        </ButtonCont>
                    </ModalView>
                </ModalViewParent>
            </Modal>

            {apiAuthToken != '' &&
                <WebView
                    ref={webViewRef}
                    style={{
                        height: '90%',
                        width: '100%'
                    }}
                    mixedContentMode='always'
                    thirdPartyCookiesEnabled={true}
                    sharedCookiesEnabled={true}
                    webviewDebuggingEnabled={true}
                    onError={handleError}
                    onHttpError={handleError}
                    onLoadStart={handleLoadStart}
                    onLoadEnd={handleLoadEnd}
                    onLoadProgress={({nativeEvent}) => {
                        let loadingProgress = nativeEvent.progress;
                        handleLoadStart();
                    }}
                    source={{
                        uri: `${mainSite}/activity-view?activity_name=${current_workout_activity.shortcode}&activity_id=${current_workout_activity.id}&game_type=${currentActivityGameType}&workout_id=${workoutId}&last_exercise=${isLastExercise}&auth_token=${apiAuthToken}`,
                    }}
                    onMessage={onMessage}
                />
            }

            {apiAuthToken == '' &&
                <View style={{
                    height: '100%',
                    width: '100%',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <ActivityIndicator size="small"/>
                    <WorkoutTextHeader>Loading your Exercise</WorkoutTextHeader>
                </View>
            }
        </View>
    );
}

const ModalViewParent = styled.View`
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
`;

const ModalView = styled.View`
  width: 300px;
  height: auto;
  border-radius: 15px;
  text-align: center;
  padding: 25px;
  background: white;

`

export const ButtonCont = styled.TouchableOpacity`
  height: 35px;
  width: 200px;
  background: #3366cc;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50px;
  margin-top: 15px;
`

export const ButtonText = styled.Text`
  font-size: 16px;
  color: white
`;

export default GameView;
